import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import Assessment from '@app/src/types/assessment'
import { AssessmentTemplateWithClassificationRules, ResponseItem } from '@app/src/types/resourceExplorer'
import { Stack, Box } from '@mui/material'
import React from 'react'
import AssessmentResponseItemRow from '../../../ResourceCollection/Collections/Assessments/AssessmentResponseItemRow'

interface TransparencyStandardAssessmentDetailedReviewProps {
  responseItems: ResponseItem[]
  assessment: Assessment
  maxRowsForLongAnswers: number
}

const staleTime = 60000

const TransparencyStandardAssessmentDetailedReview = ({
  responseItems,
  assessment,
  maxRowsForLongAnswers,
}: TransparencyStandardAssessmentDetailedReviewProps) => {
  const { data: assessmentTemplateWithClassificationRules } =
    useFetchResource<AssessmentTemplateWithClassificationRules>({
      key: [FetchKey.AssessmentTemplateWithClassificationRules, assessment.assessmentTemplate.id],
      endpoint: endpoints.assessmentTemplateWithClassificationRules(assessment.assessmentTemplate.id),
      options: {
        staleTime: staleTime,
      },
    })

  const questions = assessmentTemplateWithClassificationRules?.questions ?? []

  const currentResponseItems = responseItems.filter(responseItem =>
    questions.some(question => responseItem.requestItem.template?.id === question.id),
  )

  const currentAssessmentRules = assessment.assessmentTemplate?.rules?.filter(rule =>
    questions.some(question => rule.questionId === question.id),
  )

  return (
    <Box sx={{ width: '800px' }}>
      <Stack spacing={2} p={3}>
        {currentResponseItems.map(responseItem => (
          <AssessmentResponseItemRow
            key={responseItem.id}
            responseItem={responseItem}
            assessmentRules={currentAssessmentRules?.filter(
              rule => rule.questionId === responseItem.requestItem.template?.id,
            )}
            maxRowsForLongAnswers={maxRowsForLongAnswers}
          />
        ))}
      </Stack>
    </Box>
  )
}

export default TransparencyStandardAssessmentDetailedReview
